
import gsap from 'gsap';
import scrollTrigger from 'gsap/dist/ScrollTrigger';

gsap.registerPlugin(scrollTrigger)

const heroTall = document.querySelector('.hero-tall')

window.addEventListener('frame-ready', () => {
    if(heroTall) init()
})

function init() {

    const duration = .2
    const ease = "power2.inOut"

    const heroOverlay = document.querySelector('.hero-tall--overlay')
    const heroImage = document.querySelector('.hero-tall--background > div')
    const heroTitle = document.querySelector('.hero-tall h1')
    const heroCopy = document.querySelector('.hero-tall--intro')
    const heroButton = document.querySelector('.hero-tall .button')

    const tl = gsap.timeline()

    // Animate overlay
    tl.to(heroOverlay, { opacity: 1, ease })

    // Animate image
    tl.to(heroImage, { opacity: 1, ease }, "-=.4")
    tl.addLabel('heroImage')
    tl.to(heroImage, { scale: 1, ease: 'circ.out', duration: 2 }, "-=.6")

    // Animate text
    Array.from(heroTitle.querySelectorAll('span')).forEach((line, i) => {
        tl.to(line, { opacity: 1, translateY: 0,  ease }, `heroImage+=${i * 0.1}`)
    })

    if(heroButton) {
        tl.to(heroButton, { opacity: 1, ease }, 'heroImage')
    }

    tl.to(heroCopy, { opacity: 1, ease }, 'heroImage+=.3')
        // -- Unique hero sections
        // Variable links ( Sustainability / Who we are )
        const variableSection = document.querySelector('.WhoWeArePage .hero-tall, .SustainabilityListPage .hero-tall')
        if(variableSection) {
            let section = variableSection.nextElementSibling
            let items = section.querySelectorAll('.row > div')
            tl.to(items, {
                translateY: 0,
                opacity: 1,
                stagger: {
                    each: '0.1',
                    grid: 'auto',
                    from: 'random',
                    ease
                }
            }, 'heroImage')
        }

        // Careers page
        const teamSection = document.querySelector('.hero-tall-careers--staggered')
        if(teamSection) {
            let items = teamSection.querySelectorAll('.staggered-video, .staggered-image')
            tl.to(items, {
                translateY: 0,
                opacity: 1,
                stagger: {
                    each: '0.1',
                    grid: 'auto',
                    from: 'random',
                    ease
                }
            }, 'heroImage')

            // Playing with perspective
            // window.addEventListener('mousemove', e => {
            //     let x = e.pageX
            //     let y = e.pageY
            //     console.log(x = x / 100 * -1)
            //     console.log(y = y / 100 * -1)
            //     gsap.to(items[1], { rotationX: x, rotationY: y })
            // })
        }

        const contactSection = document.querySelector('.ContactPage .hero-tall')
        if(contactSection) {
            const flair = contactSection.querySelector('.background-flair')
            const g = contactSection.querySelector('.goodman-flair')

            tl.to([flair, g], { opacity: 1, ease }, 'heroImage')
        }

        const textureLinks = document.querySelectorAll('.texture-list--links a')
        if(textureLinks.length > 0) {
            tl.to(textureLinks, { opacity: 1, translateX: 0, ease, stagger: {
                    each: '0.1',
                    ease
            }}, 'heroImage')
        }
}
